import { useQuery } from '@tanstack/react-query'
import { fetchPatientCareProviders } from '../services/patient';
import { useParams } from 'react-router-dom';

const GetPatientCareProviders = () => {
  const { pommeId } = useParams();
  // Get patient ID from URL params or localStorage
  const patientId = pommeId || localStorage.getItem('patient');

  const getPatientCareProviders = useQuery({
    queryKey: ['patient_care_providers', patientId],
    queryFn: () => fetchPatientCareProviders(patientId),
    enabled: !!patientId, // Only run query if we have a patient ID
  })
  return getPatientCareProviders;
}

export default GetPatientCareProviders
